<template>
  <coverage-page :customPageControl="pageControl" />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "PremiumWaiver",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "豁免保障",
        pageBlock: [],
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
